import { useRef, useEffect } from "react";

export function QuillEditor({ value, onChange, placeholder = "Write here…", label, className = "" }) {
  const containerRef = useRef(null);
  const editorRef = useRef(null);
  const onChangeRef = useRef(onChange);
  const ignoreNextSync = useRef(false);
  onChangeRef.current = onChange;

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    let mounted = true;

    const init = async () => {
      const Quill = (await import("quill")).default;
      await import("quill/dist/quill.snow.css");
      if (!mounted || !containerRef.current) return;

      const editor = new Quill(containerRef.current, {
        theme: "snow",
        placeholder,
      });
      editorRef.current = editor;

      if (value) editor.clipboard.dangerouslyPasteHTML(value);

      editor.on("text-change", () => {
        ignoreNextSync.current = true;
        const html = editor.root.innerHTML;
        if (html === "<p><br></p>") onChangeRef.current("");
        else onChangeRef.current(html);
      });
    };

    init();
    return () => {
      mounted = false;
      editorRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (ignoreNextSync.current) {
      ignoreNextSync.current = false;
      return;
    }
    const editor = editorRef.current;
    if (!editor) return;
    const current = editor.root.innerHTML;
    const next = value || "";
    if (current === next || (current === "<p><br></p>" && !next)) return;
    editor.clipboard.dangerouslyPasteHTML(next);
  }, [value]);

  return (
    <div className={className}>
      {label && <p className="text-muted small mb-1">{label}</p>}
      <div ref={containerRef} style={{ minHeight: "120px" }} />
    </div>
  );
}
